module.exports = __webpack_public_path__ + "static/media/departments.4b926a9c.svg";